(function () {
  'use strict';

  var STORAGE = {
    firstTouch: 'fg_analytics_first_touch_v1',
    sessionTouch: 'fg_analytics_session_touch_v1',
    visitorSeen: 'fg_analytics_visitor_seen_v1'
  };

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  var RESOURCE_PAGES = {
    '/pages/know-your-number-pricing-workshop': {
      id: 'know_your_number_pricing_workshop',
      name: 'Know Your Number™ Pricing Workshop',
      cluster: 'pricing_profitability',
      content: 'episodes_5_6',
      formId: '1121486'
    },
    '/pages/10-questions-to-ask-an-event-organizer': {
      id: '10_questions_event_organizer',
      name: '10 Questions to Ask an Event Organizer',
      cluster: 'getting_started',
      content: 'episode_2',
      formId: '1091434'
    },
    '/pages/festival-booth-equipment-checklist': {
      id: 'festival_booth_equipment_checklist',
      name: 'Festival Booth Equipment Checklist',
      cluster: 'booth_equipment',
      content: 'episodes_3_4',
      formId: '1091874'
    },
    '/pages/daily-sales-log-for-festival-vendors': {
      id: 'daily_sales_log',
      name: 'Daily Sales Log for Festival Vendors',
      cluster: 'running_vendor_business',
      content: 'event_tracking',
      formId: '1092876'
    }
  };

  var RESOURCE_EXTENSIONS = /\.(pdf|docx?|xlsx?|csv|zip|txt|rtf)(?:$|[?#])/i;
  var debug = new URLSearchParams(window.location.search).get('fg_analytics_debug') === '1';

  function analyticsStorageAllowed() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true;
  }

  function safeParse(value) {
    if (!value) return null;
    try { return JSON.parse(value); } catch (e) { return null; }
  }

  function safeStorage(storage, method, key, value) {
    if (!analyticsStorageAllowed()) return null;
    try {
      if (method === 'get') return storage.getItem(key);
      if (method === 'set') storage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }

  function cleanPath(pathname) {
    var path = pathname || '/';
    if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
    return path;
  }

  function referrerSource(referrer) {
    if (!referrer) return { source: 'direct', medium: 'none' };
    try {
      var host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, '');
      if (/facebook\.com$/.test(host) || /fb\.com$/.test(host)) return { source: 'facebook', medium: 'social' };
      if (/instagram\.com$/.test(host)) return { source: 'instagram', medium: 'social' };
      if (/tiktok\.com$/.test(host)) return { source: 'tiktok', medium: 'social' };
      if (/youtube\.com$/.test(host) || /youtu\.be$/.test(host)) return { source: 'youtube', medium: 'social' };
      if (/google\./.test(host)) return { source: 'google', medium: 'organic' };
      if (/bing\.com$/.test(host)) return { source: 'bing', medium: 'organic' };
      if (/duckduckgo\.com$/.test(host)) return { source: 'duckduckgo', medium: 'organic' };
      return { source: host || 'referral', medium: 'referral' };
    } catch (e) {
      return { source: 'referral', medium: 'referral' };
    }
  }

  function campaignFromLocation() {
    var params = new URLSearchParams(window.location.search);
    var campaign = {};
    var hasUtm = false;
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        campaign[key] = value.slice(0, 160);
        hasUtm = true;
      }
    });

    if (!campaign.utm_source || !campaign.utm_medium) {
      var inferred = referrerSource(document.referrer);
      if (!campaign.utm_source) campaign.utm_source = inferred.source;
      if (!campaign.utm_medium) campaign.utm_medium = inferred.medium;
    }

    campaign.has_utm = hasUtm;
    campaign.landing_page = cleanPath(window.location.pathname) + window.location.search;
    campaign.first_referrer = document.referrer || '';
    campaign.captured_at = new Date().toISOString();
    return campaign;
  }

  function initializeAttribution() {
    var current = campaignFromLocation();
    var first = safeParse(safeStorage(window.localStorage, 'get', STORAGE.firstTouch));
    if (!first) {
      first = current;
      safeStorage(window.localStorage, 'set', STORAGE.firstTouch, JSON.stringify(first));
    }

    var session = safeParse(safeStorage(window.sessionStorage, 'get', STORAGE.sessionTouch));
    if (current.has_utm || !session) {
      session = current;
      safeStorage(window.sessionStorage, 'set', STORAGE.sessionTouch, JSON.stringify(session));
    }

    return { first: first, session: session || current };
  }

  var attribution = initializeAttribution();
  var visitorWasSeen = safeStorage(window.localStorage, 'get', STORAGE.visitorSeen) === '1';
  safeStorage(window.localStorage, 'set', STORAGE.visitorSeen, '1');

  function deviceType() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua))) return 'tablet';
    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'mobile';
    return 'desktop';
  }

  function pageContext() {
    var main = document.querySelector('#MainContent');
    var session = attribution.session || {};
    var first = attribution.first || {};
    return {
      source_page_path: cleanPath(window.location.pathname),
      source_page_title: (document.title || '').slice(0, 200),
      page_template: main && main.dataset ? (main.dataset.template || '') : '',
      device_type: deviceType(),
      visitor_type: visitorWasSeen ? 'returning_browser' : 'new_browser',
      session_source: session.utm_source || '',
      session_medium: session.utm_medium || '',
      session_campaign: session.utm_campaign || '',
      session_content: session.utm_content || '',
      session_term: session.utm_term || '',
      first_touch_source: first.utm_source || '',
      first_touch_medium: first.utm_medium || '',
      first_touch_campaign: first.utm_campaign || '',
      first_landing_page: first.landing_page || '',
      first_referrer: first.first_referrer || ''
    };
  }

  function emit(eventName, eventData) {
    var payload = Object.assign({}, pageContext(), eventData || {});
    payload.event_name = eventName;

    try {
      document.dispatchEvent(new CustomEvent('fg:' + eventName, { detail: payload }));
    } catch (e) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
    } catch (e) {}

    if (debug && window.console) console.info('[FG Analytics]', eventName, payload);
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 120) || 'resource';
  }

  function filenameFromUrl(href) {
    try {
      var url = new URL(href, window.location.href);
      return decodeURIComponent(url.pathname.split('/').pop() || '');
    } catch (e) {
      return '';
    }
  }

  function extensionFromUrl(href) {
    var filename = filenameFromUrl(href);
    var match = filename.match(/\.([a-z0-9]{2,5})$/i);
    return match ? match[1].toLowerCase() : '';
  }

  function resourceFromAnchor(anchor) {
    var href = anchor.href || anchor.getAttribute('href') || '';
    var currentResource = RESOURCE_PAGES[cleanPath(window.location.pathname)];
    var dataId = anchor.getAttribute('data-fg-resource-id');
    var dataName = anchor.getAttribute('data-fg-resource');
    var filename = filenameFromUrl(href);

    return {
      id: dataId || (currentResource && currentResource.id) || slugify(filename || anchor.textContent),
      name: dataName || (currentResource && currentResource.name) || filename || (anchor.textContent || '').trim() || 'Resource',
      cluster: anchor.getAttribute('data-fg-resource-cluster') || (currentResource && currentResource.cluster) || '',
      content: anchor.getAttribute('data-fg-resource-content') || (currentResource && currentResource.content) || '',
      formId: (currentResource && currentResource.formId) || ''
    };
  }

  function isDownloadAnchor(anchor) {
    if (!anchor) return false;
    var href = anchor.href || anchor.getAttribute('href') || '';
    if (!href) return false;
    if (anchor.hasAttribute('download')) return true;
    if (anchor.hasAttribute('data-fg-resource') || anchor.hasAttribute('data-fg-resource-id')) return true;
    if (RESOURCE_EXTENSIONS.test(href)) return true;
    return /\/files\//i.test(href) && !/\.(jpe?g|png|gif|webp|svg|avif)(?:$|[?#])/i.test(href);
  }

  function resourcePageFromHref(href) {
    try {
      var url = new URL(href, window.location.href);
      return RESOURCE_PAGES[cleanPath(url.pathname)] || null;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var anchor = target.closest('a');
    if (!anchor) return;

    if (isDownloadAnchor(anchor)) {
      var resource = resourceFromAnchor(anchor);
      emit('resource_download', {
        resource_id: resource.id,
        resource_name: resource.name,
        resource_cluster: resource.cluster,
        resource_content: resource.content,
        shopify_form_id: resource.formId || '',
        resource_url: anchor.href || anchor.getAttribute('href') || '',
        resource_extension: extensionFromUrl(anchor.href || anchor.getAttribute('href') || ''),
        link_text: (anchor.textContent || '').trim().slice(0, 160)
      });
      return;
    }

    var destinationResource = resourcePageFromHref(anchor.href || anchor.getAttribute('href') || '');
    if (destinationResource) {
      emit('resource_cta_click', {
        resource_id: destinationResource.id,
        resource_name: destinationResource.name,
        resource_cluster: destinationResource.cluster,
        resource_content: destinationResource.content,
        shopify_form_id: destinationResource.formId || '',
        destination_path: cleanPath(new URL(anchor.href, window.location.href).pathname),
        link_text: (anchor.textContent || '').trim().slice(0, 160)
      });
    }
  }, true);

  var submittedResourceForms = typeof WeakSet === 'function' ? new WeakSet() : null;

  document.addEventListener('submit', function (event) {
    var resource = RESOURCE_PAGES[cleanPath(window.location.pathname)];
    if (!resource) return;
    var form = event.target;
    var main = document.querySelector('#MainContent');
    if (!form || !main || !main.contains(form)) return;
    if (submittedResourceForms && submittedResourceForms.has(form)) return;
    if (submittedResourceForms) submittedResourceForms.add(form);
    emit('resource_form_submit', {
      resource_id: resource.id,
      resource_name: resource.name,
      resource_cluster: resource.cluster,
      resource_content: resource.content,
      shopify_form_id: resource.formId || ''
    });
  }, true);

  function onReady() {
    var resource = RESOURCE_PAGES[cleanPath(window.location.pathname)];
    if (resource) {
      emit('resource_page_view', {
        resource_id: resource.id,
        resource_name: resource.name,
        resource_cluster: resource.cluster,
        resource_content: resource.content,
        shopify_form_id: resource.formId || ''
      });
    }

    if (debug) {
      window.FGAnalytics = window.FGAnalytics || {};
      window.FGAnalytics.attribution = attribution;
      window.FGAnalytics.resources = RESOURCE_PAGES;
      window.FGAnalytics.emit = emit;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
